'use client'

import Bugsnag from '@bugsnag/js'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ErrorView } from '@/app/[locale]/_components/ErrorView'
import useNotFoundData from '@/hooks/useNotFoundData'
import type { AppLocale } from '@/types/general'

interface Props {
	readonly error: Error
	readonly locale: AppLocale
}

const queryClient = new QueryClient()

function ErrorContent({ error, locale }: Props) {
	useEffect(() => {
		Bugsnag.notify(error)
	}, [error])

	const { data } = useNotFoundData({ locale })

	return <ErrorView data={data?.data} disableTopMargin />
}

export default function Err(props: Props) {
	return (
		<QueryClientProvider client={queryClient}>
			<ErrorContent {...props} />
		</QueryClientProvider>
	)
}
